import React from 'react';
import { AudioPlayerState } from '../../Context/AudioContext';
import { Paragraph } from '../Types/ArticleTypes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlay,
  faPause,
  faStop,
  faSpinner,
  faVolumeHigh,
} from '@fortawesome/free-solid-svg-icons';
import Button from '../../Components/Button';

interface ArticleReadAloudButtonProps {
  playbackState: AudioPlayerState;
  playbackParagraph?: Paragraph;
  articleId: string;
  onPlay: () => void;
  onPause: () => void;
  onStop: () => void;
}

export default function ArticleReadAloud({
  playbackState,
  playbackParagraph,
  articleId,
  onPlay,
  onPause,
  onStop,
}: ArticleReadAloudButtonProps) {
  if (playbackParagraph) {
    return (
      <div className="flex flex-row gap-0.5">
        {playbackState === AudioPlayerState.Play ? (
          <div
            className="cursor-pointer flex justify-center items-center w-10 h-10 text-center text-gray-600 whitespace-nowrap bg-gray-200 rounded-bl-lg rounded-tl-lg"
            onClick={onPause}
          >
            <FontAwesomeIcon icon={faPause} className="h-5 w-5 align-middle" />
          </div>
        ) : (
          <div
            className="cursor-pointer flex justify-center items-center w-10 h-10 text-center text-gray-600 whitespace-nowrap bg-gray-200 rounded-bl-lg rounded-tl-lg"
            onClick={onPlay}
          >
            <FontAwesomeIcon icon={faPlay} className="h-5 w-5 align-middle" />
          </div>
        )}
        <div
          className="cursor-pointer flex justify-center items-center w-10 h-10 text-center text-gray-600 whitespace-nowrap bg-gray-200 rounded-br-lg rounded-tr-lg"
          onClick={onStop}
        >
          <FontAwesomeIcon icon={faStop} className="h-5 w-5 align-middle" />
        </div>
      </div>
    );
  }

  return (
    <Button variant="primary" onClick={onPlay}>
      {playbackState === AudioPlayerState.Play ? (
        <FontAwesomeIcon
          icon={faSpinner}
          className="animate-spin h-5 w-5 mr-1 align-middle"
        />
      ) : (
        <FontAwesomeIcon
          icon={faVolumeHigh}
          className="h-5 w-5 mr-1 align-middle"
        />
      )}
      Read Aloud
    </Button>
  );
}
